import { useState } from 'react';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const useOnboardingValidation = () => {
  const [errors, setErrors] = useState({});

  const validatePhone = (phoneData) => {
    // Si c'est un objet avec phoneVerified à true, c'est valide
    if (typeof phoneData === 'object' && phoneData.phoneVerified === true) {
      return null;
    }

    // Sinon, on valide le numéro de téléphone
    const phone = typeof phoneData === 'object' ? phoneData.phone : phoneData;

    if (!phone) return 'Le numéro de téléphone est requis';
    if (!isValidPhoneNumber(phone)) {
      return 'Format de numéro invalide';
    }
    return null;
  };

  const validateBirthday = (birthday) => {
    if (!birthday) return 'La date de naissance est requise';
    
    const age = new Date().getFullYear() - new Date(birthday).getFullYear();
    if (age < 16) return 'Vous devez avoir au moins 16 ans';
    if (age > 100) return 'Date de naissance invalide';
    
    return null;
  };

  const validateActivities = (activities) => {
    if (!activities?.length) return 'Sélectionnez au moins une activité';
    if (activities.length > 5) return 'Maximum 5 activités';
    return null;
  };

  const validateLocation = (location) => {
    if (!location?.placeId) return 'La localisation est requise';
    return null;
  };

  const validatePhoto = (photo) => {
    if (!photo) return null; // Photo optionnelle
    
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (photo.size > maxSize) return 'La photo ne doit pas dépasser 5MB';
    
    const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!validTypes.includes(photo.type)) {
      return 'Format de photo invalide (JPG, PNG ou WEBP uniquement)';
    }
    
    return null;
  };

  const validateStep = (stepId, data) => {
    let error = null;
    
    switch (stepId) {
      case 'phone':
        // Si phoneVerified est true, on considère l'étape comme valide
        if (data.phoneVerified === true) {
          error = null;
        } else {
          error = validatePhone(data.phone);
        }
        break;
      case 'birthday':
        error = validateBirthday(data.birthday);
        break;
      case 'activities':
        error = validateActivities(data.activities);
        break;
      case 'location':
        error = validateLocation(data.location);
        break;
      case 'photo':
        error = validatePhoto(data.photo);
        break;
      default:
        error = null;
    }

    setErrors(prev => ({ ...prev, [stepId]: error }));
    return !error;
  };

  return {
    errors,
    validateStep,
    clearError: (stepId) => setErrors(prev => ({ ...prev, [stepId]: null }))
  };
}; 